import { GridSortItem } from '@mui/x-data-grid-pro';

import { QueryOption } from '../@types';
import { httpClient, HttpMethod } from './http-client';
import { NotificationTemplate, NotificationTemplatePaginateListResponse, SendGridTemplate } from '../@types/notificationTamplate.type';
import { isNotArrayEmpty } from '../utils/array-utils';

export const getNotificationTemplatesPaginated = (queryOptions: QueryOption): Promise<NotificationTemplatePaginateListResponse> => {
  const { page, pageSize, sortModel } = queryOptions;
  let url = `/notificationTemplatesPaginated?limit=${pageSize}&page=${page + 1}`;

  if (sortModel && isNotArrayEmpty(sortModel as GridSortItem[], 0)) {
    url += `&order_by=${sortModel[0]?.field}&order_direction=${sortModel[0]?.sort}`;
  }

  return httpClient<NotificationTemplatePaginateListResponse>(url, HttpMethod.Get);
};

export const getNotificationTemplateById = (id: number): Promise<NotificationTemplate> => {
  return httpClient<NotificationTemplate>(`/notificationTemplates/${id}`, HttpMethod.Get);
};

export const createNotificationTemplate = (notificationTemplate: NotificationTemplate): Promise<NotificationTemplate> => {
  return httpClient<NotificationTemplate>('/notificationTemplates', HttpMethod.Post, notificationTemplate);
};

export const updateNotificationTemplate = (id: number, notificationTemplate: NotificationTemplate): Promise<void> => {
  return httpClient<void>(`/notificationTemplates/${id}`, HttpMethod.Put, notificationTemplate);
};

export const getSendGridTemplates = (): Promise<SendGridTemplate[]> => {
  return httpClient<SendGridTemplate[]>('/sendgridTemplates', HttpMethod.Get);
};